import type { Device } from '../api/types'
import { config } from '../config'
import { QrCode } from './QrCode'

/**
 * QR-mærkatet der sættes på enheden.
 *
 * QR-koden indeholder en URL (".../e/K7M2QX9P") frem for bare koden, så mærkatet
 * kan scannes med mobilens eget kamera - også af en elektriker der ikke har appen
 * åben. Siden bag kræver stadig login (docs/DECISIONS.md beslutning 024).
 *
 * Koden står også med tal og bogstaver under QR-koden, så den kan tastes ind,
 * hvis mærkatet er blevet ridset eller snavset.
 */

/** URL'en der ender i QR-koden. */
export function deviceUrl(code: string) {
  // Rigtig adresse i drift; ved lokal udvikling bruges den adresse, browseren står på.
  const base = config.publicUrl || window.location.origin
  return `${base.replace(/\/$/, '')}/e/${code}`
}

/** Tegner QR-koden som SVG, så den er skarp uanset printerens opløsning. */
export function DeviceQr({ code, size = 128 }: { code: string; size?: number }) {
  return <QrCode value={deviceUrl(code)} size={size} />
}

/** Ét mærkat, som det ser ud på papir. */
export function DeviceLabel({ device }: { device: Device }) {
  return (
    <div className="device-label">
      <DeviceQr code={device.code} size={132} />

      <div className="device-label__text">
        <div className="device-label__name">{device.name}</div>
        {device.location && <div className="device-label__line">{device.location}</div>}
        {device.serialNumber && <div className="device-label__line">Serienr. {device.serialNumber}</div>}

        <div className="device-label__code">{device.code}</div>

        <div className="device-label__scan">Scan for service</div>
      </div>
    </div>
  )
}
